module.exports = __webpack_public_path__ + "static/img/what1.a0c01a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what1.png
// module id = cTDe
// module chunks = 0